import { useState } from 'react'
import * as m from '~/paraglide/messages'
import { getLocale, setLocale } from '~/paraglide/runtime.js'
import { Button } from '~/shared/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/shared/ui/dropdown-menu'

const languages: { code: 'en' | 'de'; name: string; flag: string }[] = [
  { code: 'de', name: 'Deutsch', flag: '🇦🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
]

export function LanguageSwitcher() {
  const [locale, setCurrentLocale] = useState(() => getLocale())

  const handleLanguageChange = (langCode: 'en' | 'de') => {
    if (langCode !== locale) {
      setLocale(langCode)
      setCurrentLocale(langCode)
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={m.switchLanguage()}>
          <span className="text-xs font-semibold">{locale.toUpperCase()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={locale === lang.code ? 'bg-accent' : ''}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
